module.exports = __webpack_public_path__ + "static/media/temp-pic.8af98a53.jpg";